filters.unitConverter={};
filters.unitConverter.statics = {
        /**
         * Decimal precision of calculation results
         * Used to mitigiate rounding effects of floating point calculations
         * @type Number
         */
        PRECISION : 12
    };
filters.currentLocale= 'de_DE';
/**
 * The cache for converter functions. Is used to prevent unnecessary regeneration of functions.
 *
 */
filters.converterFunctionCache= {};

angular.module('cfn')
	.filter('unitConverter', ['$log', function($log) {

	/**
	 * Checks whether the given unit is available, throws exception if not
	 *
	 * @param {String} unitName the name of the unit to check
	 * @throws {CAS.L10N.ConverterException} (unchecked) if invalid unitName is passed
	 * @private
	 */
	var checkUnit = function (unitName) {
	    var me = this;

	    if (!Lookup.Unit.hasOwnProperty(unitName)) {
	    	$log.error("Unit '" + unitName + "' is unknown and can not be used for conversions");
	    }
	};

	/**
	 * Checks whether the conversion given by unitFrom and unitTo is valid, throws an exception if not
	 *
	 * @param {String} unitFrom The name of the unit to convert from
	 * @param {String} unitTo The name of the unit to convert to
	 * @throws {CAS.L10N.ConverterException} (unchecked) if invalid unit is passed or conversion is invalid
	 * @private
	 */
	var checkConversion = function (unitFrom, unitTo) {
	    var me = this,
	        from,
	        to;

	    // check if unit names are valid
	    checkUnit(unitFrom);
	    checkUnit(unitTo);

	    // get lookup data for from and to unit
	    from = Lookup.Unit[unitFrom];
	    to = Lookup.Unit[unitTo];

	    if (!from || !to) {
	    	// At least one unit could not be found
	    	// Error has already been logged
	    } else if (to.base !== from.base) {
	    	// check whether from and to base are equal
	    	$log.error("Unit conversion from unit '" + unitFrom + "' to unit '" + unitTo + "' is invalid because from.base unit is '" + from.base + "' and to.base unit is '" + to.base + "'");
	    } else {
	    	// Conversion should be possible
	    	return true;
	    }
	    // For some reason we cannot convert
	    return false;
	};

    /**
     * Creates a key for the function cache for the given combination of
     * current locale, from and to unit
     *
     * @param {String} unitFrom The unit to convert from
     * @param {String} unitTo The unit to convert to
     * @return {String} The cache key
     * @protected
     * @throws {CAS.IllegalArgumentException} (unchecked) on unknown unit or invalid conversion
     */
	var getCacheKey = function (unitFrom, unitTo) {
	        var me = this;

	        checkConversion(unitFrom, unitTo);

	        return filters.currentLocale + '-' + unitFrom + '-' + unitTo;
	};

	return function(value, unitFrom, unitTo) {
		 var me = this,
         precision = filters.unitConverter.statics.PRECISION,
         unitBase,
         base,
         from,
         to,
         cacheKey,
         cacheKeyFromBase,
         cacheKeyToBase,
         funcFromBase,
         funcToBase;

	// Converter can work even if unit is unknown
	if (unitFrom === unitTo) {
		return parseFloat(value);
	}

    // check if this is a valid conversion
    var conversionWorks = checkConversion(unitFrom, unitTo);

    if (!conversionWorks) {
    	// Abort to prevent runtime errors
    	$log.error("Aborting conversion, returning 0");
    	return 0;
    }

    // get lookup data
    from = Lookup.Unit[unitFrom];
    to = Lookup.Unit[unitTo];
    unitBase = from.base;

    // get cache key
    cacheKey = getCacheKey(unitFrom, unitTo);

    // return cached version if available
    if (filters.converterFunctionCache[cacheKey]) {
    	$log.debug("Getting cached version for key: " + cacheKey);

        return filters.converterFunctionCache[cacheKey](value);
     }

     // get cache keys for fromBase and toBase functions
     cacheKeyFromBase = getCacheKey(unitBase, unitTo);
     cacheKeyToBase = getCacheKey(unitFrom, unitBase);

     // get cached or create new fromBase converter function
     if (!filters.converterFunctionCache[cacheKeyFromBase]) {

    	 //$log.debug("Caching new converter base -> to function: " + cacheKeyFromBase);


    	 filters.converterFunctionCache[cacheKeyFromBase] = function (value) {
             if (isNaN(value)) {
            	 $log.error("Value '" + value + "' is not a valid number");
             }
	            return parseFloat(((value * to.factor) / to.divisor + to.offset).toFixed(precision));
	        };
     }
     funcFromBase =filters.converterFunctionCache[cacheKeyFromBase];

     // get cached or create new toBase converter function
     if (!filters.converterFunctionCache[cacheKeyToBase]) {

    	 //$log.debug("Caching new converter from -> base function: " + cacheKeyToBase);

         filters.converterFunctionCache[cacheKeyToBase] = function (value) {
             if (isNaN(value)) {
            	 $log.error("Value '" + value + "' is not a valid number");
             }
             return parseFloat(((value - from.offset) / from.factor * from.divisor).toFixed(precision));
         };
     }
     funcToBase = filters.converterFunctionCache[cacheKeyToBase];

     if (unitFrom === unitTo) {

    	 //$log.debug("Caching new converter passthru function: " + cacheKey);


         // from and to are the same -> add passthru function
    	 filters.converterFunctionCache[cacheKey] = function (value) {
             if (isNaN(value)) {
            	 $log.error("Value '" + value + "' is not a valid number");
             }
             return parseFloat(value);
         };

     } else if (unitFrom !== unitBase && unitTo !== unitBase) {

    	//$log.debug("Caching new converter from -> to function: " + cacheKey);

         // neither from nor to is base -> add composite function
    	 filters.converterFunctionCache[cacheKey] = function (value) { return funcFromBase(funcToBase(value)); };
     }

     // return function from cache, cached versions of the functions converting
     // from and to the base (e.g. unitFrom or unitTo are unitBase) were created
     // and cached before
     return filters.converterFunctionCache[cacheKey](value);
	};

}]);